import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { ImUsers, ImUserTie } from "react-icons/im";
import { IoApps, IoAppsSharp } from "react-icons/io5";

import { handleError } from "utils/handleError";
import { countUsers } from "services/UserService";
import { countClients } from "services/ClientService";


export const Dashboard = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(['dashboard', "common"])
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language
    }

    const [totalCitizenUsers, setTotalCitizenUsers] = useState(0);
    const [totalOfficerUsers, setTotalOfficerUsers] = useState(0);
    const [totalForeignUsers, setTotalForeignUsers] = useState(0);
    const [totalCitizenClients, setTotalCitizenClients] = useState(0);
    const [totalOfficerClients, setTotalOfficerClients] = useState(0);
    const [totalForeignClients, setTotalForeignClients] = useState(0);

    useEffect(() => {
        countUsers(headers, {
            filters: {
                "officer": { value: "1", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalOfficerUsers(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });

        countUsers(headers, {
            filters: {
                "type": { value: "CITIZEN", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalCitizenUsers(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });

        countUsers(headers, {
            filters: {
                "type": { value: "FOREIGN", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalForeignUsers(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });

        countClients(headers, {
            filters: {
                "realmType": { value: "OFFICER", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalOfficerClients(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });

        countClients(headers, {
            filters: {
                "realmType": { value: "CITIZEN", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalCitizenClients(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });

        countClients(headers, {
            filters: {
                "realmType": { value: "FOREIGN", matchMode: 'equals' }
            }
        }).then((res) => {
            setTotalForeignClients(res.data)
        }).catch((error) => {
            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("Không có dữ liệu"), life: 3000 });
        });
    }, []);

    return (
        <div className="grid">
            <Toast ref={toast} />
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("officerUserTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalOfficerUsers}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <ImUserTie />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("citizenUserTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalCitizenUsers}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <ImUsers />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("foreignUserTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalForeignUsers}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-gray-500 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <ImUsers />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("officerClientTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalOfficerClients}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <IoAppsSharp />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("citizenClientTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalCitizenClients}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <IoApps />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-4">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{t("foreignClientTotal")}</span>
                            <div className="text-900 font-medium text-xl">{totalForeignClients}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-gray-500 border-round" style={{ width: '3rem', height: '3rem' }}>
                            <IoApps />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
